module.exports = __webpack_public_path__ + "static/media/FP-Battery-Pack_SS_002.25202a3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/faq/change-batteries/FP-Battery-Pack_SS_002.jpg
// module id = 1201
// module chunks = 0